import { useApolloQuery } from '@/gql/apolloWrapper';
import { BillingInfo, useGetBillingInfoQuery } from '@/gql/generated';
import useCurrentCompany from '@/hooks/useCurrentCompany';
import useCurrentPlan from '@/hooks/useCurrentPlan/useCurrentPlan';
import isAdmin from '@/utils/isAdmin';
import { computed, ref, Ref } from '@nuxtjs/composition-api';
import { resolveIsDedicated, resolveIsElite } from './planKey';

let init;

const isLoading = ref(false);
const billingInfo = ref<BillingInfo>();
const currentTier: Ref<number | undefined> = ref();

const setupHook = (force) => {
  const { companyId } = useCurrentCompany();
  const { tierNumber } = useCurrentPlan();
  currentTier.value = tierNumber.value;
  if (isAdmin.value) {
    const { onResult } = useApolloQuery(
      useGetBillingInfoQuery,
      { input: { companyId: companyId.value } },
      { pending: isLoading },
      { force }
    );

    onResult(({ getBillingInfo: res }) => {
      billingInfo.value = res as BillingInfo;
    });
  }
};

const isElite = computed(() => resolveIsElite(billingInfo.value));

const isDedicated = computed(() => resolveIsDedicated(billingInfo.value));

const cycleEndDate = computed(
  () => billingInfo.value?.coreSubscription?.periodEndsAt
);

// Stub for tracking events (no-op)
const trackEvent = (_event: string, _data?: object) => {};

const useCompanyBillingInfo = (force = false) => {
  if (!init || force) {
    setupHook(force);
  }

  return {
    isLoading,
    billingInfo,

    // computed
    isElite,
    isDedicated,
    cycleEndDate,

    // Event tracking stub (no-op)
    trackEvent,
  };
};

export default useCompanyBillingInfo;
